<app-tractors-history-toolbar
  [tractors]="tractors"
  [loadingVisible]="toolbarLoadingVisible"
  (load)="load($event)"
  (export)="export()"
  [request]="request"></app-tractors-history-toolbar>

<app-tractors-history-popup
  [tractors]="tractors"
  [loadingVisible]="popupLoadingVisible"
  [loader]="routeLoader"
  (load)="load($event)"
  [request]="request"></app-tractors-history-popup>
<div class="history-container flex flex-row items-stretch overflow-hidden w-full">

  <div [@slideLeftInOut]="selectedTab === 0 || selectedTab === 2 || selectedTab === 4"
       (@slideLeftInOut.done)="animationDone($event)"
       class="w-1/5 flex flex-col items-stretch overflow-hidden mr-1">
    <app-tractors-history-metrics [loader]="routeLoader"
                                  class="dash-container w-full flex-1 overflow-hidden mb-1 bg-white">
    </app-tractors-history-metrics>

    <app-tractors-history-details-grid [renderer]="routeRenderer"
                                       class="details-grid-container w-full flex-1 overflow-hidden bg-white"></app-tractors-history-details-grid>
  </div>

  <div class="flex flex-col flex-1 items-stretch overflow-hidden">
    <dx-tabs class="tabs-container w-full flex-initial overflow-hidden bg-white"
             [dataSource]="tabs" keyExpr="id" [selectedItem]="{id: selectedTab}"
             (onItemClick)="selectTab($event)"></dx-tabs>

    <div #mainContainer class="main-container w-full flex flex-col flex-auto overflow-hidden bg-white">
      <app-tractors-history-map [ngClass]="{flex: true, hidden: !(selectedTab !== 3 && selectedTab !== 4)}"
                                [renderer]="routeRenderer"
                                [loader]="routeLoader"
                                [routeParams]="routeParams"
                                [onResize]="contentSizeChanged$"></app-tractors-history-map>
      <app-tractors-history-messages [ngClass]="{flex: true, hidden: !(selectedTab === 3)}"
                                     [loader]="routeLoader"
                                     [onResize]="contentSizeChanged$"
                                     [renderer]="routeRenderer"></app-tractors-history-messages>
      <app-tractors-history-fuel [ngClass]="{flex: true, 'flex-col': true, hidden: !(selectedTab === 4)}"
                                 [loader]="routeLoader"
                                 [onResize]="contentSizeChanged$"></app-tractors-history-fuel>
    </div>

    <app-tractors-history-graphs
      [loader]="routeLoader"
      [renderer]="routeRenderer"
      [@slideInOut]="selectedTab === 2"
      (@slideInOut.done)="animationDone($event)"
      class="graphs-container w-full flex-initial mt-1 overflow-hidden bg-white">
    </app-tractors-history-graphs>
  </div>

</div>

<dx-load-panel
  class="route-loading"
  shadingColor="rgba(0,0,0,0.2)"
  [(visible)]="isRouteLoading"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [closeOnOutsideClick]="false">

  <div *dxTemplate="let data of 'content'">{{routeLoader.loadedStr()}}</div>
</dx-load-panel>
